import React from 'react';
import ProfileCard from './components/ProfileCard.tsx';
import PromoBanner from './components/PromoBanner.tsx';
import QuickActions from './components/QuickActions.tsx';
import RecentActivity from './components/RecentActivity.tsx';

function Dashboard() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 lg:gap-6">
      <div className="xl:col-span-2 space-y-4 lg:space-y-6">
        <ProfileCard />
        <PromoBanner />
        <RecentActivity />
      </div>
      <div className="xl:col-span-1">
        <QuickActions />
      </div>
    </div>
  );
}

export default Dashboard;